import React from "react";
import { Link } from "react-router-dom";
import blog1 from "../../images/blog/1.jpg";
import blog2 from "../../images/blog/2.jpg";
import "./style.css";

const BlogGrid = () => {
  return (
    <div className="blog-area blog-grid section-padding">
      <div className="container">
        <div className="col-l2">
          <div className="section-title-1 text-center">
            <span>From Our Blog</span>
            <h2>Latest News</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-6 col-12">
            <div className="blog-item">
              <div className="blog-img">
                <img src={blog1} alt="" />
              </div>
              <div className="blog-content">
                <h3>
                  <Link to="/blog/1">
                    How will the Vacant Unit Tax affect real estate transactions
                    and realtors in the upcoming years?
                  </Link>
                </h3>
                <ul className="post-meta">
                  <li>By Babette Turner</li>
                  <li>Jan 5, 2023</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-12">
            <div className="blog-item">
              <div className="blog-img">
                <img src={blog2} alt="" />
              </div>
              <div className="blog-content">
                <h3>
                  <Link to="/blog/2">Second Blog Coming!!</Link>
                </h3>
                <ul className="post-meta">
                  <li>By Author Name</li>
                  <li>Dec 17, 2022</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogGrid;
